(function() {
  window.poaLoaded = true;
  console.log('poa-variant-details2.js executing');

  var metafields = {};
  var variantMaterialMap = {};
  var variantMaterialLinkMap = {};

  function createDetailRow(label, value, unit, link) {
    unit = unit || '';
    link = link || null;
    if (!value) return '';
    var val = link ? '<a href="' + link + '" target="_blank" rel="noopener noreferrer">' + value + '</a>' : value;
    return '<tr><td><span style="text-transform: uppercase; font-size: 12px">' + label + '</span></td><td>' + val + (unit ? ' ' + unit : '') + '</td></tr>';
  }

  function renderDetailsTable(material) {
    var details = "<table class='details-list' style='border-collapse: collapse; width: 100%; padding: 0'>";
    details += createDetailRow('Collection', metafields.primary_collection_title, '', metafields.primary_collection_url);
    details += createDetailRow('Material', material || metafields.material, '', metafields.custom_material_link || metafields.material_link);
    details += createDetailRow('Width', metafields.width);
    details += createDetailRow('Pearl Size', metafields.pearl_size);
    details += createDetailRow('Lengths', metafields.lengths);
    if (metafields.pearl_surface) {
      details += '<tr><td><span style="text-transform: uppercase; font-size: 12px">Pearl Grade</span></td><td><button type="button" id="pearl-grade-trigger" class="link underlined-link" style="text-align:left;">' + metafields.pearl_surface + '</button></td></tr>';
    }
    details += createDetailRow('Stone Type', metafields.stone_type);
    details += createDetailRow('Pearl Shape', metafields.pearl_shape);
    details += createDetailRow('Pearl Purity', metafields.pearl_purity);
    details += createDetailRow('Pearl Type', metafields.pearl_type);
    details += createDetailRow('Band Size', metafields.band_size);
    details += createDetailRow('Dimensions', metafields.dimensions);
    details += '</table>';
    return details;
  }

  function processAccordions() {
    var logos = {
      cygnet: '<img width="120px" src="https://cdn.shopify.com/s/files/1/0882/8980/4581/files/CBPF_Logo.svg?v=1763686684" alt="Cygnet Bay Logo" class="farm-logo">',
      broken: '<img width="120px" src="https://cdn.shopify.com/s/files/1/0882/8980/4581/files/BB_Pearls_Farm.svg?v=1726128083" alt="Broken Bay Logo" class="farm-logo">'
    };

    document.querySelectorAll('.accordion__content').forEach(function(content) {
      var parentAccordion = content.closest('.product__accordion');
      var titleEl = parentAccordion ? parentAccordion.querySelector('.accordion__title') : null;

      if (content.innerHTML.includes('[display_farms]')) {
        if (metafields.farm_location) {
          content.innerHTML = content.innerHTML.replace(/\[display_farms\]/g, metafields.farm_location);
        } else if (parentAccordion) {
          parentAccordion.style.display = 'none';
        }
      }

      if (content.innerHTML.includes('[details]')) {
        var details = renderDetailsTable(metafields.material);
        if (details.match(/<tr>/)) {
          content.innerHTML = details;
          var gradeBtn = content.querySelector('#pearl-grade-trigger');
          if (gradeBtn) {
            gradeBtn.addEventListener('click', function() {
              var popup = document.querySelector('[id^="ProductPopup-popup_wrJTz7"]');
              if (popup) popup.click();
            });
          }
        } else if (parentAccordion) {
          parentAccordion.style.display = 'none';
        }
      }

      if (titleEl && titleEl.textContent.includes('Sustainably Grown at')) {
        var farm = (metafields.farm_location || '').toLowerCase();
        var logoHTML = '';
        if (farm.includes('cygnet')) logoHTML += logos.cygnet;
        if (farm.includes('broken')) logoHTML += logos.broken;
        if (logoHTML && !titleEl.querySelector('.farm-logo')) titleEl.innerHTML += logoHTML;
      }
    });
  }

  function init() {
    console.log('poa init() running');
    var variantDetails = document.getElementById('variantDetails');
    if (!variantDetails) {
      console.log('variantDetails not found');
      return;
    }

    var mapEl = document.getElementById('variantMaterialData');
    if (mapEl) {
      try {
        variantMaterialMap = JSON.parse(mapEl.textContent.trim());
        console.log('variantMaterialMap:', variantMaterialMap);
      } catch(e) {
        console.log('map parse error:', e);
      }
    }

    var linkMapEl = document.getElementById('variantMaterialLinkData');
    if (linkMapEl) {
      try {
        variantMaterialLinkMap = JSON.parse(linkMapEl.textContent.trim());
        console.log('variantMaterialLinkMap:', variantMaterialLinkMap);
      } catch(e) {
        console.log('link map parse error:', e);
      }
    }

    var urlVariantId = new URLSearchParams(window.location.search).get('variant');
    var correctMaterial = null;
    var correctMaterialLink = null;
    
    // First, check if material or link were stored in sessionStorage from swatch selection
    var storedMaterial = sessionStorage.getItem('selectedVariantMaterial');
    var storedMaterialLink = sessionStorage.getItem('selectedVariantMaterialLink');
    if (storedMaterial) {
      correctMaterial = storedMaterial;
      sessionStorage.removeItem('selectedVariantMaterial');
      console.log('using material from sessionStorage:', correctMaterial);
    }
    if (storedMaterialLink) {
      correctMaterialLink = storedMaterialLink;
      sessionStorage.removeItem('selectedVariantMaterialLink');
      console.log('using material link from sessionStorage:', correctMaterialLink);
    }

    if (urlVariantId) {
      // Prefer URL variant lookup if available
      correctMaterial = variantMaterialMap[urlVariantId] || correctMaterial;
      var variantLink = variantMaterialLinkMap[urlVariantId];
      if (variantLink) {
        correctMaterialLink = variantLink;
      }
    }
    
    console.log('urlVariantId:', urlVariantId, 'correctMaterial:', correctMaterial, 'correctMaterialLink:', correctMaterialLink);

    Array.from(variantDetails.attributes).forEach(function(attr) {
      if (attr.name.startsWith('data-')) {
        var key = attr.name.replace('data-', '').replace(/-/g, '_');
        metafields[key] = attr.value.trim();
      }
    });

    console.log('metafields.material before override:', metafields.material);
    console.log('metafields.material_link before override:', metafields.material_link, 'metafields.custom_material_link before override:', metafields.custom_material_link);

    if (correctMaterial) {
      metafields.material = correctMaterial;
    }
    if (correctMaterialLink) {
      metafields.custom_material_link = correctMaterialLink;
      metafields.material_link = correctMaterialLink;
    }

    console.log('metafields.material after override:', metafields.material);
    console.log('metafields.material_link after override:', metafields.material_link, 'metafields.custom_material_link after override:', metafields.custom_material_link);

    processAccordions();
  }

  function waitForSubscribe() {
    if (typeof window.subscribe === 'function') {
      window.subscribe('option-value-selection-change', function(event) {
        var selectedOptionValues = event.data && event.data.selectedOptionValues;
        if (!selectedOptionValues || !selectedOptionValues.length) return;

        var productHandle = window.location.pathname.split('/products/')[1];
        if (productHandle) productHandle = productHandle.split('?')[0];
        if (!productHandle) return;

        fetch('/products/' + productHandle + '.json')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var product = data.product;
            var selectedOptionTexts = [];
            
            // Read currently selected values from the form
            // Get all checked radio/checkbox inputs within swatch fieldsets
            var selectedByValueId = [];
            selectedOptionValues.forEach(function(optionValueId) {
              var input = document.querySelector('input[data-option-value-id="' + optionValueId + '"]');
              if (!input) return;

              var label = document.querySelector('label[for="' + input.id + '"]');
              var optionText = label ? label.getAttribute('title') || label.textContent : input.value;
              if (!optionText) return;

              var positionMatch = input.name.match(/-(\d+)$/);
              selectedByValueId.push({
                position: positionMatch ? parseInt(positionMatch[1], 10) : 0,
                text: optionText.trim(),
              });
            });

            selectedByValueId.sort(function(a, b) {
              return a.position - b.position;
            });

            selectedOptionTexts = selectedByValueId.map(function(item) {
              return item.text;
            }).filter(Boolean);

            // Fallback: if no mapped option text was found, try other form inputs
            if (selectedOptionTexts.length === 0) {
              var selectedByName = {};
              document.querySelectorAll('[name^="options"]').forEach(function(input) {
                if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
                  var match = input.name.match(/options\[([^\]]+)\]/);
                  if (match) selectedByName[match[1]] = input.value;
                } else if (input.tagName === 'SELECT' && input.value) {
                  var match = input.name.match(/options\[([^\]]+)\]/);
                  if (match) selectedByName[match[1]] = input.value;
                }
              });
              if (product.options && product.options.length > 0) {
                selectedOptionTexts = product.options.map(function(option) {
                  return selectedByName[option.name] || '';
                }).filter(Boolean);
              }
            }
            
            // Find the variant matching the selected option values
            var variant = null;
            if (selectedOptionTexts.length > 0) {
              variant = product.variants.find(function(v) {
                var variantOptions = [v.option1, v.option2, v.option3]
                  .filter(function(opt) { return opt; });
                
                // Match: variant must have same number of options and they must all match in order
                return variantOptions.length === selectedOptionTexts.length &&
                       variantOptions.every(function(opt, idx) {
                         return opt === selectedOptionTexts[idx];
                       });
              });
            }
            
            if (variant) {
              console.log('navigating to variant:', variant.id, 'options:', selectedOptionTexts);
              // Store variant material data in sessionStorage for use after page reload
              var variantMaterial = variantMaterialMap[variant.id] || variant.title;
              if (variantMaterial) {
                sessionStorage.setItem('selectedVariantMaterial', variantMaterial);
                console.log('storing material:', variantMaterial);
              }
              var variantMaterialLink = variantMaterialLinkMap[variant.id];
              if (variantMaterialLink) {
                sessionStorage.setItem('selectedVariantMaterialLink', variantMaterialLink);
                console.log('storing material link:', variantMaterialLink);
              }
              window.location.href = window.location.pathname + '?variant=' + variant.id;
            } else {
              console.log('no variant found', {
                selectedOptionValues: selectedOptionValues,
                selectedOptionTexts: selectedOptionTexts,
                sampleVariant: product.variants && product.variants[0]
              });
            }
          })
          .catch(function(e) {
            console.log('fetch error:', e);
          });
      });
    } else {
      setTimeout(waitForSubscribe, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  waitForSubscribe();
})();